function setupScrollVideo(videoElement, triggerElement, triggerHook = 0, controllerOptions = {}) {
  if (!videoElement || !triggerElement) {
    console.error("Invalid elements: videoElement or triggerElement is missing.");
    return;
  }

  if ("none" !== videoElement.preload && videoElement.src) {
    try {
      videoElement.load();
    } catch (err) {
      console.warn(`Failed to load video: ${videoElement.src}, error: ${err}`);
      return;
    }
  }

  const initializeController = () => {
    const videoDuration = videoElement.duration;
    if (isNaN(videoDuration) || !isFinite(videoDuration) || videoDuration <= 0) {
      console.error("Invalid video duration:", { videoDuration, src: videoElement.src });
      return;
    }

    const controller = new ScrollMagic.Controller(controllerOptions);
    const scrollDuration = Math.max(videoDuration * 1000, 1);
    const validTriggerHook = Math.min(Math.max(triggerHook, 0), 1);
    const pinSceneDuration = Math.max(scrollDuration - validTriggerHook * window.innerHeight, 0);

    new ScrollMagic.Scene({
      duration: pinSceneDuration,
      triggerElement: triggerElement,
      triggerHook: 0,
    }).setPin(triggerElement).addTo(controller);

    let lastTime = -1;
    new ScrollMagic.Scene({
      duration: scrollDuration,
      triggerElement: triggerElement,
      triggerHook: validTriggerHook,
    }).on("progress", (e) => {
      const currentTime = videoDuration * e.progress;
      if ((isFinite(currentTime) && Math.abs(currentTime - lastTime) > 0.05)
        || currentTime === 0 || currentTime >= (videoDuration - 0.05)) {
        videoElement.currentTime = currentTime;
        lastTime = currentTime;
      }
    }).addTo(controller);

    console.log("Video scroll scenes created successfully.");
  };

  if (videoElement.readyState < HTMLMediaElement.HAVE_METADATA) {
    videoElement.addEventListener("loadedmetadata", () => {
      console.log("Video metadata loaded.");
      initializeController();
    }, { once: true });
    return;
  }

  initializeController();
}